import React, { useEffect, useState } from "react";
import { Card, Modal, ProgressBar } from "react-bootstrap";
import { variables } from "../../Variables.json";
import api from "../../seller-apis/api";
import axios from "axios";
import { useAlert } from "react-alert";
import { GenUtilities } from "../../utilities/GenUtilities";
import servicesApi from "../../seller-apis/servicesApi";

const isPdfFile = (fileName = "") => {
  const cleanFileName = fileName.split("?")[0];
  return cleanFileName.toLowerCase().endsWith(".pdf");
};

const getFileNameFromPath = (filePath = "") => {
  try {
    const pathname = filePath.startsWith("https") ? new URL(filePath).pathname : filePath;
    return pathname.split("?")[0].split("/").pop() || "cancelled-cheque.pdf";
  } catch (error) {
    return filePath.split("?")[0].split("/").pop() || "cancelled-cheque.pdf";
  }
};

function BankDetails(props) {
  const alert = useAlert();
  // Bank details
  var chequeFileName;
  const [acNo, setAcNo] = useState(props?.data?.acno);
  const [acName, setAcName] = useState(props?.data?.name);
  const [ifscCode, setIfscCode] = useState(props?.data?.ifsc);
  const [error, setError] = useState(false);
  const [cancelledCheque, setCancelledCheque] = useState("");
  const [chequeUploadProg, setChequeUploadProg] = useState("");
  const [fileName, setFileName] = useState("");
  const [profileData, setProfileData] = useState({});
  const [show, setShow] = useState(false);
  const isCancelledChequePdf = isPdfFile(props?.data?.cancelledCheque || "");

  const downloadCancelledCheque = () => {
    if (!cancelledCheque) return;

    // const link = document.createElement("a");
    // link.href = cancelledCheque;
    // link.setAttribute("download", getFileNameFromPath(props?.data?.cancelledCheque));
    // link.setAttribute("target", "_blank");
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // // seller document not able to download SL-1206 --docket name and type was not set
    let data = {
      "bucket": "seller_doc",
      "key": "mob/products/" + getFileNameFromPath(props?.data?.cancelledCheque)
    }
    api.docs.getImage(data).then((res) => {
      const fileUrl = res.data;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", getFileNameFromPath(props?.data?.cancelledCheque));
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(err => console.log(err))
  };

  function uploadCheque(event) {
    let comImg;
    let imageFinal;
    let registerImage;
    let filesSize = 0;
    let limit = event.target.files.length;
    for (let i = 0; i < limit; i++) {
      filesSize = filesSize + event.target.files[i].size;
    }
    if (filesSize <= variables.limit.RegisterVendor.gstSize) {
      for (let i = 0; i < 1; i++) {
        if (!GenUtilities.isFileExtensionValid(event.target.files[i].name, ['.jpg', '.jpeg', '.png', '.pdf'])) {
            alert.info('Please upload only valid JPG, JPEG, PNG or PDF files.');
            event.target.value = "";
            return;
        }
        var str = event.target.files[i].name;
        // let extension = event.target.files[i].name.slice(
        //   event.target.files[i].name.lastIndexOf(".")
        // );
        const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
        comImg = str.replace(0, str.lastIndexOf("."));
        let vendorId = localStorage.getItem("vendorId");
        imageFinal = GenUtilities.removeSpacesFromName("CancelledCheque_" + vendorId + "_" + comImg);
        registerImage = event.target.files[0];
        chequeFileName = imageFinal;
        setFileName(chequeFileName);
        // seller document not able to download SL-1206 --docket name and type was not set
        var data = {
           imageName: imageFinal,
           type: "products",
           bucket: "seller_doc"
        };
        servicesApi
          .saveImage(data)
          .then((res) => {
            axios({
              method: "put",
              url: res.data,
              data: registerImage,
              onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                setChequeUploadProg(
                  Math.round((100 * data.loaded) / data.total)
                );
              },
            })
              .then((response) => {
                console.log(response);
                setChequeUploadProg();
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => console.log(err));
      }
    } else {
      alert.info("File size can be upto 2 Mb max.");
    }
  }
  useEffect(() => {
    setProfileData(props.profile);
  }, [props.profile]);

  // SL-1148
  const getImageParams = (name) => {
    if (!name) return null;

    // Old mobile uploads had "mob/products/" prefix stored 
    if (name.startsWith('mob/products/')) {
      return { bucket: "seller_doc", key: name };
    }

    return { bucket: "seller_doc", key: 'mob/products/' + name  };
  };
  // SL-1148 ends

  useEffect(() => {
    if (show) {
      // SL-1148
      let data = getImageParams(props.data.cancelledCheque)
      if(data === null){
        return;
      }
      // SL-1148 ends
      api.docs.getImage(data).then((res) => {
        setCancelledCheque(res?.data)
      }).catch(err => {
        console.log(err)
      })
    }
  }, [show])

  const saveStep3Data = () => {
    let registrationdata = {
      _id: props.vendorId,
      bankDetail: {
        acno: acNo,
        name: acName,
        ifsc: ifscCode,
        cancelledCheque: fileName,
      },
      "sendStepsCompleteMail": true,
      "profileStepsCompleted": [
        ...props.profile.profileStepsCompleted,
        {
          name: 'step3',
          value: true,
        }
      ]
    };
    // console.log(registrationdata);
    api.seller
      .updateInfo(registrationdata)
      .then((res) => {
        props.changeStep("complete");
        props.updateResponseData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getobject = (data) => {
    let compArray = props?.profile?.profileStepsCompleted || [];

    for (var i = 0, iLen = compArray.length; i < iLen; i++) {

      if (compArray[i].name == data) {
        return compArray[i].value;
      }
      // return false;
    }
  }
  return (
    <>
      {props?.data?.acno ? (
        <Card className="card-box">
          <div className="theme-shed1 p-2 bank-account">
            <div className="title theme-shed1 p-2">Bank Details</div>
            <div className="details-container p-2">
              <div className="details mb-2">
                <div className="title">Account Number</div>
                <div className="data">{props?.data?.acno}</div>
              </div>
              <div className="details mb-2 d-flex align-items-center gap-10">
                <div className="data">Cancelled Cheque :</div>
                <div className="d-flex align-items-center">
                  <div className="view-icon" onClick={() => setShow(true)}>
                    <img src="/view-icon.webp" alt="icon" />
                  </div>
                  <div
                    className="view-doc cursor-pointer"
                    onClick={() => setShow(true)}
                  >
                    View Document
                  </div>
                </div>
              </div>
              <div className="details mb-2">
                <div className="title">Account Name</div>
                <div className="data">{props?.data?.name}</div>
              </div>
              <div className="details mb-2">
                <div className="title">IFSC Code</div>
                <div className="data">{props?.data?.ifsc}</div>
              </div>
            </div>
          </div>
        </Card>
      ) : (
        <Card className="m-1 card-box">
          <div className="theme-shed1 p-2 bank-account">
            <div className="title theme-shed1 p-2">Bank Details</div>

            {/* <ul className="d-flex l-n px-1 mb-0  pt-2 pb-1">
                        <li className="mx-3">
                          <h6 className="ff_pop text-dark">A/c No.</h6>
                        </li>
                      </ul> */}
            <div className="theme-shed1 p-2">
              <input
                type="text"
                name="phone"
                className="profile-input w-60"
                id="phone"
                placeholder="Account Number*"
                onChange={(e) => setAcNo(e.target.value)}
                value={acNo}
              />
              {error && (acNo == "" || acNo == undefined) ? (
                <div className="validation-error">
                  Account Number is required
                </div>
              ) : (
                ""
              )}
            </div>
            {/* <ul className="d-flex l-n px-1 mb-0  pt-2 pb-1">
                        <li className="mx-3">
                          <h6 className="ff_pop text-dark">A/c Holder Name</h6>
                        </li>
                      </ul> */}
            <div className="theme-shed1 p-2 document-upload d-flex">
              <div className="cheque-title">Attach Cancelled Cheque Here*:</div>
              <div className="upload-box w-34">
                <div className="placeholder-text">
                  {fileName ? fileName : "Upload Document..."}
                </div>
                {chequeUploadProg && (
                  <ProgressBar
                    id="progress-B"
                    now={chequeUploadProg}
                    label={`${chequeUploadProg}%`}
                  />
                )}
                <label
                  for="cheque-upload"
                  className="profile_resubmit_btn cheque-padding"
                // onClick={() => handleShowverifyfield("TAN")}
                >
                  {fileName ? "Change" : "Upload"}
                </label>
                <input
                  type="file"
                  hidden
                  accept=".png, .jpg, .jpeg,.pdf"
                  onChange={(e) => uploadCheque(e)}
                  className="ff_pop"
                  id="cheque-upload"
                ></input>
              </div>
            </div>
            {error && fileName == "" ? (
              <div className="validation-error px-2">
                Please upload cancelled cheque
              </div>
            ) : (
              ""
            )}
            <div className="theme-shed1 p-2">
              <input
                type="text"
                name="phone"
                className="profile-input w-60"
                placeholder="Account Name*"
                id="phone"
                onChange={(e) => setAcName(e.target.value)}
                value={acName}
              />
              {error && (acName == "" || acName == undefined) ? (
                <div className="validation-error">Account name is required</div>
              ) : (
                ""
              )}
            </div>
            <div className="theme-shed1 p-2">
              {/* <ul className="d-flex l-n px-1 mb-0  pt-2 pb-1">
                          <li className="mx-3">
                            <h6 className="ff_pop text-dark">IFSC Code</h6>
                          </li>
                        </ul> */}
              <input
                type="text"
                name="phone"
                className="profile-input w-60"
                placeholder="IFSC Code*"
                id="phone"
                onChange={(e) => setIfscCode(e.target.value)}
                value={ifscCode}
              />
              {error && (ifscCode == "" || ifscCode == undefined) ? (
                <div className="validation-error">IFSC code is required</div>
              ) : (
                ""
              )}
              {/* <div className="fs-13">{email}</div> */}
            </div>
            <div className="text-center my-3">
              {!acNo || !acName || !ifscCode || !fileName ? (
                <button
                  className="profile-submit profile-submit-disable"
                  onClick={() => setError(true)}
                >
                  Submit
                </button>
              ) : (
                <button
                  className="profile-submit"
                  onClick={() => saveStep3Data()}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </Card>
      )}
      <Modal
        className="custom-modal"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Body>
          {isCancelledChequePdf ? (
            <div className="text-center p-4">
              <div
                className="d-flex align-items-center justify-content-center mx-auto mb-3"
                style={{
                  width: "64px",
                  height: "64px",
                  borderRadius: "50%",
                  background: "#f2f7f7",
                  color: "#165B5B",
                  fontSize: "30px",
                }}
              >
                <i className="bi bi-file-earmark-pdf"></i>
              </div>
              <h6 className="mb-2">Cancelled cheque is a PDF</h6>
              <p className="text-muted fs-13 mb-3">
                Download the document to view the cancelled cheque.
              </p>
              <button
                className="profile-submit"
                onClick={downloadCancelledCheque}
                disabled={!cancelledCheque}
              >
                Download Cheque
              </button>
            </div>
          ) : (
            <img
              src={cancelledCheque}
              alt="cancel-cheque"
              className="img-responsive img-fluid"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default BankDetails;
